import { Component } from 'react'
/** @jsx jsx */
import { jsx, css } from '@emotion/core'

class LastDummyNode extends Component {
  render () {
    return (
      // this.props.connectDropTarget(
      <div css={css`width: 100%; height: 300px; background-color: var(--baseColor);`} />
      // )
    )
  }
}

export default LastDummyNode
